import { Alert, AlertDescription, AlertTitle } from '@sunstone/ui';
import { TriangleAlert } from 'lucide-react';
import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class AuthErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    // Only log Auth0 errors, not all errors
    if (error.message.includes('auth0-spa-js') || error.message.includes('secure origin')) {
      console.warn('Auth0 error (expected in non-HTTPS development):', error.message);
    }
  }

  render() {
    if (this.state.hasError && this.state.error?.message.includes('secure origin')) {
      // In development without HTTPS, render the app without Auth0
      console.log('Rendering without Auth0 due to HTTPS requirement');
      return (
        <div className="min-h-screen bg-background">
          <div className="mx-auto max-w-7xl px-6 py-4">
            <Alert className="border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800/30 dark:bg-amber-950/20 dark:text-amber-300">
              <TriangleAlert className="h-4 w-4 text-amber-500" />
              <AlertTitle>Development Mode</AlertTitle>
              <AlertDescription>
                Auth0 requires HTTPS. Authentication is disabled in this preview.
              </AlertDescription>
            </Alert>
          </div>
          {this.props.children}
        </div>
      );
    }

    return this.props.children;
  }
}
